import React from 'react';
import ResultDay from "./day/ResultDay";
import {liveConfig} from "../../../constant/config";
import Welcome from "../Welcome";
import ResultNight from "./night/ResultNight";

const Wrapper = ({onStartDraw, result, ...props}) => {
    const isWelcome = result.results.length === 0;

    return (
        <div className="h-100">
            <div className="content result-day h-100">
                <div className={`container-draw ${isWelcome ? "wel" : ""}`}>
                    {
                        isWelcome ? <Welcome onStartDraw={onStartDraw}/> :
                            <>
                                {
                                    result.isNight ? <ResultNight
                                            drawAt={result.drawAt}
                                            rightResults={result.rightResults}
                                            resultLeft={result.results}
                                            config={liveConfig}
                                            {...props}/>
                                        : <ResultDay
                                            drawAt={result.drawAt}
                                            rightResults={result.rightResults}
                                            resultLeft={result.results}
                                            config={liveConfig}
                                            {...props}
                                        />
                                }
                            </>
                    }
                    <div className="lay3"/>
                    <div className="lay4"/>
                </div>
            </div>
        </div>
    );
};

export default Wrapper;